'use strict';

(function ($, pix) {
    'use strict';

    if (!pix) {
        pix = window.pix || {};
    }

    //should be moved to a module
    function attachListeners(selector, eventName, fn) {
        var els = document.querySelectorAll(selector);
        for (var i = 0; i < els.length; i++) {
            var el = els[i];
            el.addEventListener(eventName, fn);
        }
    }

    //should be moved to a module
    function removeListeners(selector, eventName, fn) {
        var els = document.querySelectorAll(selector);
        for (var i = 0; i < els.length; i++) {
            var el = els[i];
            el.removeEventListener(eventName, fn);
        }
    }

    //should be moved to a module
    function getSiblingsArray(element) {
        return [].slice.call(element.parentElement.children);
    }

    //should be moved to a module
    function decodeHtmlEntity(str) {
        var $txt = $(document.createElement("div")).html(str);
        return $txt.html().replace(/&gt;/g, '>').replace(/&lt;/g, '<');
    }

    (function handlebarsTemplatesHelper() {
        if (!pix) {
            pix = {};
        }
        if (!pix.templates) {
            pix.templates = {};
        }

        pix.loadTemplate = function (name, url, callback) {
            if (pix.templates === undefined || pix.templates[name] === undefined) {
                return $.ajax({
                    type: 'GET',
                    url: url
                }).then(function (data) {
                    pix.templates[name] = window.Handlebars.compile(data);
                    if (!!callback) {
                        callback(pix.templates[name]);
                    }
                });
            }
        };
    })();

    //should be moved to module
    function touch_detection() {
        return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    }

    (function touchDetection() {
        var onFirstTouch = function onFirstTouch() {
            // we could use a class
            document.documentElement.classList.add('touch');

            // we only need to know once that a human touched the screen, so we can stop listening now
            window.removeEventListener('touchstart', onFirstTouch, { passive: true, capture: false });
        };
        if (touch_detection()) {
            window.addEventListener('touchstart', onFirstTouch, { passive: true, capture: false });
        }
    })();

    (function hideEmptySection() {
        var shopifySections = document.querySelectorAll('.shopify-section');
        var shopifySectionsArray = !!shopifySections ? [].slice.call(shopifySections) : [];
        shopifySectionsArray.forEach(function (el) {
            if (el.children.length < 1) {
                el.classList.add('hide');
            }
        });
    })();

    (function scrollBeyond() {
        var slideDownSelector = '.slick-down';
        var slideDown = document.querySelector(slideDownSelector);
        if (!!slideDown) {
            attachListeners(slideDownSelector, 'click', function (e) {
                e.preventDefault();
                var $scrollPast = $(this.parentElement),
                    scrollTo = $scrollPast.offset().top + $scrollPast.height();
                $('html, body').animate({
                    scrollTop: scrollTo
                });
            });
        }
    })();

    (function checkIfiOS() {

        // add an ios specific class to all videos
        var _checkIfiOSonLoad = function _checkIfiOSonLoad() {
            var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
            if (iOS) {
                var vids = document.getElementsByTagName('video');
                for (var i = 0; i < vids.length; i++) {
                    vids[i].classList.add('ios-device');
                    if (vids[i].parentElement.classList.contains('limitless-video')) {
                        vids[i].parentElement.classList.add('ios-vid');
                    }
                }
            }
        };
        document.addEventListener("DOMContentLoaded", _checkIfiOSonLoad);
    })();

    window.pix = $.extend(true, window.pix, pix);
})(jQuery, window.pix);
//# sourceMappingURL=pix.js.map
